import { redirect } from "react-router-dom";
export function getAuthToken() {
  const token = localStorage.getItem("token");
  if (!token) {
    return;
  }
  return token;
}
export function tokenLoader() {
  return getAuthToken();
}
export function checkAuthLoader() {
  const token = getAuthToken();
  if (!token) {
    return redirect("/auth");
  }
}
export function logout() {
  localStorage.removeItem("token");
  redirect("auth");
}
export function getToken() {
  const token = localStorage.getItem("token");
  if (token) {
    return token;
  }
  redirect("auth");
}
